import HeaderSponsored from '../../headerSponsored';
import './headerCardGlobal.sass';

/**
 * Renderiza el encabezado de una tarjeta global para eventos deportivos,
 * mostrando la liga y el estado del juego (en vivo, próximo, finalizado, etc.).
 */
export default function HeaderCardGlobal({ data, indexJson }) {
  return (
    <HeaderSponsored data={data} prefixClass="card-global" indexJson={indexJson}/>
  )
}